import React, { useState, useEffect } from 'react';
import {
  Play, Pause, SkipBack, SkipForward, Shuffle, Repeat,
  Heart, Volume2, VolumeX, Search, Home, Library,
  ListMusic, TrendingUp, Mic2, Sparkles, Disc, Flame,
  Plus, Bell, Settings, Crown, Menu, ArrowLeft,
  Check, UserPlus, MoreHorizontal, Users, Upload,
  ChevronRight, LogOut, Lock, Mail, Eye, EyeOff,
  Shield, BarChart2, DollarSign, Radio, Users2,
  Headphones, Clock, Music,
} from 'lucide-react';
import { supabase } from "./supabaseClient";
import { NeonOrb, ArtistCard, AlbumCard, TrackRow, SectionTitle } from "./components/index";

// ═══════════════════════════════════════════════════════════════════════════════
//  ALL MOCK DATA — defined at MODULE LEVEL so they are never undefined
// ═══════════════════════════════════════════════════════════════════════════════

const CATEGORIES = ["All", "HipHop", "Trap", "R&B", "Drill", "Soul"];

const TRACKS = [
  { id: 1,  title: "FE!N",               artist: "Travis Scott",  album: "Utopia",            duration: "3:12", plays: "1.2M", img: "https://picsum.photos/seed/fein/200/200"    },
  { id: 2,  title: "MELTDOWN",           artist: "Travis Scott",  album: "Utopia",            duration: "4:06", plays: "980K", img: "https://picsum.photos/seed/meltdown/200/200" },
  { id: 3,  title: "MY EYES",            artist: "Travis Scott",  album: "Utopia",            duration: "3:44", plays: "870K", img: "https://picsum.photos/seed/myeyes/200/200"   },
  { id: 4,  title: "Gods Eye",           artist: "Metro Boomin",  album: "Heroes & Villains", duration: "3:28", plays: "760K", img: "https://picsum.photos/seed/godseye/200/200"  },
  { id: 5,  title: "Superhero",          artist: "Metro Boomin",  album: "Heroes & Villains", duration: "4:10", plays: "1.1M", img: "https://picsum.photos/seed/superhero/200/200"},
  { id: 6,  title: "Rich Flex",          artist: "Drake",         album: "Her Loss",          duration: "3:58", plays: "2.3M", img: "https://picsum.photos/seed/richflex/200/200" },
  { id: 7,  title: "Major Distribution", artist: "Drake",         album: "Her Loss",          duration: "4:22", plays: "1.5M", img: "https://picsum.photos/seed/majordist/200/200"},
  { id: 8,  title: "fukumean",           artist: "Gunna",         album: "a Gift & a Curse",  duration: "2:47", plays: "1.8M", img: "https://picsum.photos/seed/fukumean/200/200" },
];

// Detailed tracklist used inside individual album pages
const ALBUM_TRACKS = [
  { id: 1,  no: "01", title: "HYAENA",        duration: "3:45", plays: "600K" },
  { id: 2,  no: "02", title: "THANK GOD",     duration: "3:12", plays: "1.1M" },
  { id: 3,  no: "03", title: "MODERN JAM",    duration: "4:02", plays: "540K" },
  { id: 4,  no: "04", title: "MY EYES",       duration: "3:44", plays: "870K" },
  { id: 5,  no: "05", title: "PLEA",          duration: "2:58", plays: "430K" },
  { id: 6,  no: "06", title: "MELTDOWN",      duration: "4:06", plays: "980K" },
  { id: 7,  no: "07", title: "FE!N",          duration: "3:12", plays: "1.2M" },
  { id: 8,  no: "08", title: "LOST FOREVER",  duration: "3:55", plays: "390K" },
  { id: 9,  no: "09", title: "I KNOW ?",      duration: "3:21", plays: "520K" },
  { id: 10, no: "10", title: "CIRCUS MAXIMUS",duration: "3:47", plays: "710K" },
];

const ALBUMS = [
  { id: 1, title: "Utopia",            artist: "Travis Scott",   year: "2023", img: "https://picsum.photos/seed/utopia/300/300",   tracks: ALBUM_TRACKS },
  { id: 2, title: "Heroes & Villains", artist: "Metro Boomin",   year: "2022", img: "https://picsum.photos/seed/heroes/300/300",   tracks: ALBUM_TRACKS },
  { id: 3, title: "Her Loss",          artist: "Drake",          year: "2022", img: "https://picsum.photos/seed/herloss/300/300",  tracks: ALBUM_TRACKS },
  { id: 4, title: "a Gift & a Curse",  artist: "Gunna",          year: "2023", img: "https://picsum.photos/seed/gift/300/300",     tracks: ALBUM_TRACKS },
  { id: 5, title: "GUTS",              artist: "Olivia Rodrigo", year: "2023", img: "https://picsum.photos/seed/guts/300/300",     tracks: ALBUM_TRACKS },
  { id: 6, title: "SOS",               artist: "SZA",            year: "2022", img: "https://picsum.photos/seed/sosalb/300/300",   tracks: ALBUM_TRACKS },
];

const ARTISTS = [
  { id: 1, name: "Travis Scott", followers: "50.2M", genre: "HipHop", verified: true,  img: "https://picsum.photos/seed/travis/200/200",  banner: "https://picsum.photos/seed/travisbanner/1200/400"  },
  { id: 2, name: "Drake",        followers: "82.1M", genre: "HipHop", verified: true,  img: "https://picsum.photos/seed/drake/200/200",   banner: "https://picsum.photos/seed/drakebanner/1200/400"   },
  { id: 3, name: "Metro Boomin", followers: "22.5M", genre: "Trap",   verified: true,  img: "https://picsum.photos/seed/metro/200/200",   banner: "https://picsum.photos/seed/metrobanner/1200/400"   },
  { id: 4, name: "Gunna",        followers: "18.7M", genre: "Trap",   verified: true,  img: "https://picsum.photos/seed/gunna/200/200",   banner: "https://picsum.photos/seed/gunnabanner/1200/400"   },
  { id: 5, name: "SZA",          followers: "30.4M", genre: "R&B",    verified: true,  img: "https://picsum.photos/seed/szaart/200/200",  banner: "https://picsum.photos/seed/szabanner/1200/400"     },
  { id: 6, name: "21 Savage",    followers: "25.9M", genre: "Drill",  verified: false, img: "https://picsum.photos/seed/21sav/200/200",   banner: "https://picsum.photos/seed/21savbanner/1200/400"   },
];

const PLANS = [
  {
    name: "Free", price: "0", period: "mo", dim: true, colorVar: "#666",
    features: ["Ad-supported listening", "Standard audio quality", "Limited skips (6/hr)", "No offline mode"],
    cta: "Current Plan",
  },
  {
    name: "Pro", price: "9.99", period: "mo", highlight: true, colorVar: "#bc13fe",
    features: ["Zero ads ever", "Lossless 24-bit audio", "Unlimited skips", "Offline downloads", "Exclusive drops"],
    cta: "Get Pro",
  },
  {
    name: "Student", price: "4.99", period: "mo", colorVar: "#00d4ff",
    features: ["All Pro features", "50% student discount", "Easy .edu verification", "Cancel anytime"],
    cta: "Verify & Save",
  },
];

const ADMIN_STATS = [
  { label: "Total Users",    value: "124.5K", change: "↑12% this month", colorKey: "neon"  },
  { label: "Monthly Revenue",value: "$847K",  change: "↑24% this month", colorKey: "blue"  },
  { label: "Active Streams", value: "3.2K",   change: "↑5% today",       colorKey: "pink"  },
  { label: "New Artists",    value: "18",     change: "+2 this week",     colorKey: "green" },
];

const ADMIN_SONGS = [
  { id: 1, title: "FE!N",      artist: "Travis Scott", streams: "1.2M", status: "Active"  },
  { id: 2, title: "Rich Flex", artist: "Drake",        streams: "2.3M", status: "Active"  },
  { id: 3, title: "fukumean",  artist: "Gunna",        streams: "1.8M", status: "Pending" },
  { id: 4, title: "Kill Bill", artist: "SZA",          streams: "3.1M", status: "Active"  },
  { id: 5, title: "Superhero", artist: "Metro Boomin", streams: "1.1M", status: "Active"  },
];

const ADMIN_USERS = [
  { id: 1, name: "Alex Rivera",   email: "alex@example.com",    plan: "Pro",     role: "Admin",     joined: "Jan 2024" },
  { id: 2, name: "Sam Torres",    email: "sam@example.com",     plan: "Student", role: "Moderator", joined: "Feb 2024" },
  { id: 3, name: "Jordan Lee",    email: "jordan@example.com",  plan: "Free",    role: "User",      joined: "Mar 2024" },
  { id: 4, name: "Casey Morgan",  email: "casey@example.com",   plan: "Pro",     role: "User",      joined: "Mar 2024" },
];

// ─── Helpers ──────────────────────────────────────────────────────────────────
function formatTime(pct) {
  const total = 210;
  const secs = Math.floor((pct / 100) * total);
  return `${Math.floor(secs / 60)}:${(secs % 60).toString().padStart(2, "0")}`;
}

// ─── CORS-safe fetch helper (Cloudflare-compatible) ───────────────────────────
async function fetchWithCORS(url, options = {}) {
  const res = await fetch(url, {
    ...options,
    headers: {
      "Content-Type": "application/json",
      "Accept": "application/json",
      ...(options.headers || {}),
    },
    mode: "cors",
    credentials: "same-origin",
  });
  if (!res.ok) throw new Error(`HTTP ${res.status}: ${res.statusText}`);
  return res.json();
}

// ═══════════════════════════════════════════════════════════════════════════════
//  PAGES
// ═══════════════════════════════════════════════════════════════════════════════

// ─── Home ─────────────────────────────────────────────────────────────────────
function HomePage({ setPage, currentTrack, setCurrentTrack }) {
  return (
    <div className="animate-fade" style={{ paddingBottom: 20 }}>
      {/* Hero */}
      <div className="glass" style={{
        borderRadius: 24, padding: "48px 40px", marginBottom: 40, position: "relative",
        overflow: "hidden", background: "linear-gradient(135deg, rgba(188,19,254,0.12), rgba(0,212,255,0.06))",
      }}>
        <NeonOrb style={{ width: 400, height: 400, background: "rgba(188,19,254,0.15)", top: -100, right: -100 }} />
        <NeonOrb style={{ width: 200, height: 200, background: "rgba(0,212,255,0.1)", bottom: -50, left: 200 }} />
        <div style={{ position: "relative", zIndex: 1 }}>
          <div className="tag tag-pink" style={{ marginBottom: 16 }}>
            <Flame size={10} style={{ marginRight: 4 }} /> Featured Album
          </div>
          <h1 style={{ fontSize: 52, fontWeight: 800, lineHeight: 1, letterSpacing: "-0.04em", marginBottom: 16 }}>
            <span className="glow-text" style={{ color: "var(--neon)" }}>Utopia</span><br />
            <span style={{ fontSize: 28, fontWeight: 600, color: "var(--text-dim)" }}>Travis Scott</span>
          </h1>
          <p style={{ color: "var(--text-dim)", marginBottom: 28, maxWidth: 480, lineHeight: 1.6 }}>
            The highly anticipated 4th studio album. A sonic journey through Trap, Psychedelic, and Ambient landscapes.
          </p>
          <div style={{ display: "flex", gap: 12 }}>
            <button className="neon-btn" style={{ padding: "12px 28px", borderRadius: 12, fontSize: 15, display: "flex", alignItems: "center", gap: 8 }}
              onClick={() => setCurrentTrack(TRACKS?.[0])}>
              <Play size={16} fill="#fff" /> Play Now
            </button>
            <button className="ghost-btn" style={{ padding: "12px 24px", borderRadius: 12, fontSize: 14, display: "flex", alignItems: "center", gap: 8 }}
              onClick={() => setPage({ name: "album", data: ALBUMS?.[0] })}>
              <ListMusic size={16} /> View Album
            </button>
          </div>
        </div>
      </div>

      {/* Trending Tracks */}
      <section style={{ marginBottom: 40 }}>
        <SectionTitle icon={TrendingUp} color="#bc13fe">Trending Now</SectionTitle>
        <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
          {TRACKS?.map((t, i) => (
            <TrackRow key={t.id} track={t} index={i} isPlaying={currentTrack?.id === t.id} onPlay={setCurrentTrack} />
          ))}
        </div>
      </section>

      {/* Featured Artists */}
      <section style={{ marginBottom: 40 }}>
        <SectionTitle icon={Mic2} color="#00d4ff">Trending Artists</SectionTitle>
        <div className="grid-6">
          {ARTISTS?.map(a => (
            <ArtistCard key={a.id} artist={a} onClick={(artist) => setPage({ name: "artist", data: artist })} />
          ))}
        </div>
      </section>

      {/* New Releases */}
      <section style={{ marginBottom: 40 }}>
        <SectionTitle icon={Sparkles} color="#ff2d78">New Releases</SectionTitle>
        <div className="grid-4">
          {ALBUMS?.slice(0, 4).map(a => (
            <AlbumCard key={a.id} album={a} onClick={(album) => setPage({ name: "album", data: album })} />
          ))}
        </div>
      </section>
    </div>
  );
}

// ─── Search ───────────────────────────────────────────────────────────────────
function SearchPage({ setPage, currentTrack, setCurrentTrack }) {
  const [query, setQuery] = useState("");
  const [activeCategory, setActiveCategory] = useState("All");

  const filtered = (TRACKS ?? []).filter(t =>
    (query === "" || t.title.toLowerCase().includes(query.toLowerCase()) || t.artist.toLowerCase().includes(query.toLowerCase()))
  );

  return (
    <div className="animate-fade">
      <h1 style={{ fontSize: 36, fontWeight: 800, letterSpacing: "-0.03em", marginBottom: 20 }}>
        <span style={{ color: "var(--neon)" }}>Search</span> the vibe
      </h1>
      <div style={{ position: "relative", marginBottom: 20 }}>
        <Search size={18} style={{ position: "absolute", left: 16, top: "50%", transform: "translateY(-50%)", color: "var(--text-dim)" }} />
        <input value={query} onChange={e => setQuery(e.target.value)}
          placeholder="Artists, songs, albums…"
          style={{ paddingLeft: 48, fontSize: 16, borderRadius: 16, height: 56 }} />
      </div>
      <div style={{ display: "flex", gap: 8, flexWrap: "wrap", marginBottom: 32 }}>
        {CATEGORIES?.map(c => (
          <button key={c} onClick={() => setActiveCategory(c)} style={{
            padding: "8px 18px", borderRadius: 20, fontSize: 13, fontWeight: 700,
            cursor: "pointer", border: "1px solid", transition: "all 0.2s",
            fontFamily: "Syne, sans-serif",
            background: activeCategory === c ? "var(--neon)" : "transparent",
            borderColor: activeCategory === c ? "var(--neon)" : "var(--glass-border)",
            color: activeCategory === c ? "#fff" : "var(--text-dim)",
            boxShadow: activeCategory === c ? "0 0 16px rgba(188,19,254,0.4)" : "none",
          }}>{c}</button>
        ))}
      </div>

      {query === "" ? (
        <>
          <SectionTitle icon={Disc} color="#bc13fe">Browse Albums</SectionTitle>
          <div className="grid-4" style={{ marginBottom: 40 }}>
            {ALBUMS?.map(a => <AlbumCard key={a.id} album={a} onClick={(album) => setPage({ name: "album", data: album })} />)}
          </div>
          <SectionTitle icon={Mic2} color="#00d4ff">Browse Artists</SectionTitle>
          <div className="grid-6">
            {ARTISTS?.map(a => <ArtistCard key={a.id} artist={a} onClick={(artist) => setPage({ name: "artist", data: artist })} />)}
          </div>
        </>
      ) : (
        <>
          <SectionTitle icon={Music} color="#bc13fe">Results ({filtered.length})</SectionTitle>
          <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
            {filtered.length > 0 ? filtered.map((t, i) => (
              <TrackRow key={t.id} track={t} index={i} isPlaying={currentTrack?.id === t.id} onPlay={setCurrentTrack} />
            )) : (
              <div style={{ textAlign: "center", padding: 60, color: "var(--text-dim)" }}>
                <Search size={48} style={{ opacity: 0.3, marginBottom: 16 }} />
                <div style={{ fontSize: 18, fontWeight: 600 }}>No results found</div>
              </div>
            )}
          </div>
        </>
      )}
    </div>
  );
}

// ─── Library ──────────────────────────────────────────────────────────────────
function LibraryPage({ setPage, currentTrack, setCurrentTrack }) {
  return (
    <div className="animate-fade">
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 32 }}>
        <h1 style={{ fontSize: 36, fontWeight: 800, letterSpacing: "-0.03em" }}>
          Your <span style={{ color: "var(--neon)" }}>Library</span>
        </h1>
        <button className="neon-btn" style={{ padding: "10px 20px", borderRadius: 10, fontSize: 13, display: "flex", alignItems: "center", gap: 6 }}>
          <Plus size={14} /> New Playlist
        </button>
      </div>
      <SectionTitle icon={Heart} color="#ff2d78">Liked Songs</SectionTitle>
      <div style={{ display: "flex", flexDirection: "column", gap: 4, marginBottom: 40 }}>
        {TRACKS?.slice(0, 5).map((t, i) => (
          <TrackRow key={t.id} track={t} index={i} isPlaying={currentTrack?.id === t.id} onPlay={setCurrentTrack} />
        ))}
      </div>
      <SectionTitle icon={ListMusic} color="#00d4ff">Saved Albums</SectionTitle>
      <div className="grid-4">
        {ALBUMS?.slice(0, 4).map(a => <AlbumCard key={a.id} album={a} onClick={(album) => setPage({ name: "album", data: album })} />)}
      </div>
    </div>
  );
}

// ─── Artist Profile ───────────────────────────────────────────────────────────
function ArtistPage({ artist, setPage, currentTrack, setCurrentTrack, followed, toggleFollow }) {
  // Guard: artist can be undefined if navigated to directly
  if (!artist) return null;
  const artistTracks = TRACKS?.slice(0, 5) ?? [];
  const artistAlbums = ALBUMS?.slice(0, 3) ?? [];
  return (
    <div className="animate-fade">
      <div style={{ position: "relative", height: 280, marginBottom: 80, borderRadius: 20, overflow: "hidden" }}>
        <img src={artist.banner} alt="" style={{ width: "100%", height: "100%", objectFit: "cover" }} />
        <div style={{ position: "absolute", inset: 0, background: "linear-gradient(to bottom, rgba(8,8,16,0.2), rgba(8,8,16,0.95))" }} />
        <div style={{ position: "absolute", bottom: -50, left: 40, display: "flex", alignItems: "flex-end", gap: 24 }}>
          <div style={{ position: "relative" }}>
            <img src={artist.img} alt={artist.name} style={{
              width: 120, height: 120, borderRadius: "50%", objectFit: "cover",
              border: "3px solid #bc13fe", boxShadow: "0 0 30px rgba(188,19,254,0.5)",
            }} />
            {artist.verified && (
              <div style={{
                position: "absolute", bottom: 4, right: 4, background: "#bc13fe",
                borderRadius: "50%", width: 28, height: 28, display: "flex", alignItems: "center", justifyContent: "center",
                boxShadow: "0 0 12px #bc13fe",
              }}>
                <Check size={14} color="#fff" />
              </div>
            )}
          </div>
          <div style={{ paddingBottom: 8 }}>
            <div style={{ fontSize: 36, fontWeight: 800, letterSpacing: "-0.03em", textShadow: "0 2px 20px rgba(0,0,0,0.8)" }}>{artist.name}</div>
            <div style={{ color: "var(--text-dim)", fontSize: 14 }}>{artist.followers} followers · {artist.genre}</div>
          </div>
        </div>
      </div>

      <div style={{ display: "flex", gap: 12, marginBottom: 40 }}>
        <button className="neon-btn" style={{ padding: "12px 28px", borderRadius: 12, fontSize: 14, display: "flex", alignItems: "center", gap: 8 }}
          onClick={() => artistTracks[0] && setCurrentTrack(artistTracks[0])}>
          <Play size={16} fill="#fff" /> Play
        </button>
        <button onClick={() => toggleFollow?.(artist.id)} style={{
          padding: "12px 24px", borderRadius: 12, fontSize: 14, fontWeight: 700,
          border: "1px solid", fontFamily: "Syne, sans-serif", cursor: "pointer", transition: "all 0.2s",
          display: "flex", alignItems: "center", gap: 8,
          background: followed ? "var(--neon-dim)" : "transparent",
          borderColor: followed ? "var(--neon)" : "var(--glass-border)",
          color: followed ? "var(--neon)" : "var(--text-dim)",
        }}>
          <UserPlus size={16} />{followed ? "Following" : "Follow"}
        </button>
        <button className="icon-btn"><Bell size={18} /></button>
        <button className="icon-btn"><MoreHorizontal size={18} /></button>
      </div>

      <SectionTitle icon={Flame} color="#ff2d78">Top Tracks</SectionTitle>
      <div style={{ display: "flex", flexDirection: "column", gap: 4, marginBottom: 40 }}>
        {artistTracks.map((t, i) => (
          <TrackRow key={t.id} track={t} index={i} isPlaying={currentTrack?.id === t.id} onPlay={setCurrentTrack} />
        ))}
      </div>
      <SectionTitle icon={Disc} color="#00d4ff">Discography</SectionTitle>
      <div className="grid-3">
        {artistAlbums.map(a => <AlbumCard key={a.id} album={a} onClick={(album) => setPage({ name: "album", data: album })} />)}
      </div>
    </div>
  );
}

// ─── Album Page ───────────────────────────────────────────────────────────────
function AlbumPage({ album, currentTrack, setCurrentTrack }) {
  // Guard: album can be undefined
  if (!album) return null;
  const tracks = album.tracks ?? [];

  return (
    <div className="animate-fade">
      <div style={{ display: "flex", gap: 32, marginBottom: 40, alignItems: "flex-end" }}>
        <img src={album.img} alt={album.title} style={{
          width: 200, height: 200, borderRadius: 16, objectFit: "cover", flexShrink: 0,
          boxShadow: "0 16px 60px rgba(188,19,254,0.3)",
        }} />
        <div>
          <div className="tag tag-blue" style={{ marginBottom: 12 }}>Album</div>
          <h1 style={{ fontSize: 44, fontWeight: 800, letterSpacing: "-0.04em", marginBottom: 8, lineHeight: 1 }}>{album.title}</h1>
          <div style={{ color: "var(--text-dim)", fontSize: 15, marginBottom: 16 }}>
            {album.artist} · {album.year} · {tracks.length} tracks
          </div>
          <div style={{ display: "flex", gap: 10 }}>
            <button className="neon-btn" style={{ padding: "12px 28px", borderRadius: 12, fontSize: 14, display: "flex", alignItems: "center", gap: 8 }}
              onClick={() => tracks[0] && setCurrentTrack({ ...tracks[0], artist: album.artist, album: album.title, img: album.img })}>
              <Play size={16} fill="#fff" /> Play All
            </button>
            <button className="ghost-btn" style={{ padding: "12px 20px", borderRadius: 12, fontSize: 14 }}>
              <Heart size={16} />
            </button>
          </div>
        </div>
      </div>

      <div className="glass" style={{ borderRadius: 16, overflow: "hidden" }}>
        <div style={{ padding: "0 16px" }}>
          <div style={{
            display: "grid", gridTemplateColumns: "40px 1fr 100px 60px",
            padding: "12px 0", borderBottom: "1px solid rgba(255,255,255,0.06)", gap: 8,
          }}>
            {["#", "Title", "Plays", ""].map((h, i) => (
              <span key={i} style={{ color: "var(--text-dim)", fontSize: 12, textTransform: "uppercase", letterSpacing: "0.1em", fontWeight: 700, textAlign: i === 3 ? "right" : "left" }}>
                {i === 3 ? <Clock size={14} /> : h}
              </span>
            ))}
          </div>
          {tracks.map((t) => {
            const isPlaying = currentTrack?.title === t.title;
            return (
              <div key={t.id} onClick={() => setCurrentTrack({ id: t.id, title: t.title, artist: album.artist, album: album.title, duration: t.duration, img: album.img, plays: t.plays })}
                style={{
                  display: "grid", gridTemplateColumns: "40px 1fr 100px 60px", gap: 8,
                  padding: "12px 0", alignItems: "center", cursor: "pointer",
                  borderBottom: "1px solid rgba(255,255,255,0.03)", transition: "background 0.15s",
                  borderRadius: 8, background: isPlaying ? "var(--neon-dim)" : "transparent",
                }}>
                <span className="mono" style={{ textAlign: "center", color: isPlaying ? "var(--neon)" : "var(--text-dim)", fontSize: 13 }}>
                  {isPlaying ? <Play size={14} fill="var(--neon)" color="var(--neon)" /> : t.no}
                </span>
                <div>
                  <div style={{ fontWeight: 700, fontSize: 14, color: isPlaying ? "var(--neon)" : "var(--text)" }}>{t.title}</div>
                </div>
                <div style={{ color: "var(--text-dim)", fontSize: 12 }}>{t.plays}</div>
                <div className="mono" style={{ color: "var(--text-dim)", fontSize: 12, textAlign: "right" }}>{t.duration}</div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}

// ─── Profile ──────────────────────────────────────────────────────────────────
function ProfilePage({ user, setUser }) {
  const [name, setName] = useState(user.name);
  const [email, setEmail] = useState(user.email);
  const [saved, setSaved] = useState(false);

  const handleSave = () => {
    setUser({ ...user, name, email });
    setSaved(true);
    setTimeout(() => setSaved(false), 2000);
  };

  return (
    <div className="animate-fade" style={{ maxWidth: 800 }}>
      <h1 style={{ fontSize: 36, fontWeight: 800, letterSpacing: "-0.03em", marginBottom: 32 }}>
        Your <span style={{ color: "var(--neon)" }}>Profile</span>
      </h1>
      <div className="glass" style={{ borderRadius: 20, padding: 32, marginBottom: 24 }}>
        <div style={{ display: "flex", gap: 32, alignItems: "center", marginBottom: 32 }}>
          <div style={{ position: "relative" }}>
            <div style={{ width: 100, height: 100, borderRadius: "50%", overflow: "hidden", border: "3px solid rgba(188,19,254,0.4)", boxShadow: "0 0 24px rgba(188,19,254,0.25)" }}>
              <img src={`https://picsum.photos/seed/${user.name}/100/100`} alt="" style={{ width: "100%", height: "100%", objectFit: "cover" }} />
            </div>
            <button className="neon-btn" style={{ position: "absolute", bottom: -4, right: -4, width: 32, height: 32, borderRadius: "50%", fontSize: 12, display: "flex", alignItems: "center", justifyContent: "center" }}>
              <Upload size={14} />
            </button>
          </div>
          <div>
            <div style={{ fontWeight: 800, fontSize: 24 }}>{user.name}</div>
            <div style={{ color: "var(--text-dim)", marginBottom: 8 }}>{user.email}</div>
            <div className={`tag ${user.plan === "Pro" ? "tag-neon" : user.plan === "Student" ? "tag-blue" : "tag-pink"}`}>
              <Crown size={10} style={{ marginRight: 4 }} /> {user.plan} Plan
            </div>
          </div>
        </div>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 20, marginBottom: 24 }}>
          <div>
            <label style={{ fontSize: 12, color: "var(--text-dim)", textTransform: "uppercase", letterSpacing: "0.08em", fontWeight: 700, display: "block", marginBottom: 8 }}>Display Name</label>
            <input value={name} onChange={e => setName(e.target.value)} />
          </div>
          <div>
            <label style={{ fontSize: 12, color: "var(--text-dim)", textTransform: "uppercase", letterSpacing: "0.08em", fontWeight: 700, display: "block", marginBottom: 8 }}>Email</label>
            <input value={email} onChange={e => setEmail(e.target.value)} type="email" />
          </div>
        </div>
        <button onClick={handleSave} className="neon-btn" style={{ padding: "12px 28px", borderRadius: 12, fontSize: 14 }}>
          {saved ? "✓ Saved!" : "Save Changes"}
        </button>
      </div>
      <div className="glass" style={{ borderRadius: 20, padding: 32 }}>
        <div style={{ fontWeight: 800, fontSize: 20, marginBottom: 20 }}>Account Settings</div>
        {["Notifications", "Privacy", "Connected Apps", "Download Quality"].map(s => (
          <div key={s} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "16px 0", borderBottom: "1px solid rgba(255,255,255,0.06)", cursor: "pointer" }}>
            <div style={{ fontWeight: 600, fontSize: 15 }}>{s}</div>
            <ChevronRight size={18} color="var(--text-dim)" />
          </div>
        ))}
        <div style={{ marginTop: 24 }}>
          <button className="ghost-btn" style={{ padding: "12px 24px", borderRadius: 12, fontSize: 14, color: "#ff2d78", borderColor: "rgba(255,45,120,0.3)", display: "flex", alignItems: "center", gap: 8 }}>
            <LogOut size={16} /> Sign Out
          </button>
        </div>
      </div>
    </div>
  );
}

// ─── Subscription ─────────────────────────────────────────────────────────────
function SubscriptionPage() {
  return (
    <div className="animate-fade">
      <div style={{ textAlign: "center", marginBottom: 48 }}>
        <div className="tag tag-neon" style={{ marginBottom: 16, display: "inline-flex" }}>
          <Crown size={10} style={{ marginRight: 4 }} /> Upgrade Your Experience
        </div>
        <h1 style={{ fontSize: 48, fontWeight: 800, letterSpacing: "-0.04em", marginBottom: 16 }}>
          Choose Your <span className="glow-text" style={{ color: "var(--neon)" }}>Plan</span>
        </h1>
        <p style={{ color: "var(--text-dim)", fontSize: 17, maxWidth: 500, margin: "0 auto" }}>
          Unlock the full hiphop experience. No interruptions, unlimited vibes.
        </p>
      </div>
      <div className="grid-3" style={{ maxWidth: 900, margin: "0 auto" }}>
        {PLANS?.map(plan => (
          <div key={plan.name} className="glass"
            style={{
              borderRadius: 20, padding: 32, position: "relative", display: "flex", flexDirection: "column",
              borderColor: plan.highlight ? plan.colorVar : "var(--glass-border)",
              boxShadow: plan.highlight ? `0 0 40px rgba(188,19,254,0.2)` : "none",
              animation: plan.highlight ? "pulse-neon 3s ease-in-out infinite" : "none",
            }}>
            {plan.highlight && (
              <div style={{
                position: "absolute", top: -12, left: "50%", transform: "translateX(-50%)",
                background: "linear-gradient(135deg,#bc13fe,#7b00cc)", padding: "4px 16px",
                borderRadius: 20, fontSize: 12, fontWeight: 800, whiteSpace: "nowrap",
                boxShadow: "0 0 20px rgba(188,19,254,0.5)",
              }}>⚡ Most Popular</div>
            )}
            <div style={{ marginBottom: 24 }}>
              <div style={{ color: plan.colorVar, fontWeight: 800, fontSize: 14, textTransform: "uppercase", letterSpacing: "0.1em", marginBottom: 8 }}>{plan.name}</div>
              <div style={{ display: "flex", alignItems: "baseline", gap: 4 }}>
                <span style={{ fontSize: 48, fontWeight: 800, letterSpacing: "-0.04em" }}>${plan.price}</span>
                <span style={{ color: "var(--text-dim)", fontSize: 15 }}>/{plan.period}</span>
              </div>
            </div>
            <div style={{ flex: 1, marginBottom: 28 }}>
              {plan.features?.map(f => (
                <div key={f} style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 12 }}>
                  <Check size={16} color={plan.dim ? "#555" : plan.colorVar} />
                  <span style={{ fontSize: 14, color: plan.dim ? "var(--text-dim)" : "var(--text)" }}>{f}</span>
                </div>
              ))}
            </div>
            <button className={plan.highlight ? "neon-btn" : "ghost-btn"}
              style={{
                padding: "14px", borderRadius: 12, fontSize: 15, width: "100%",
                ...(!plan.highlight && !plan.dim ? { borderColor: plan.colorVar, color: plan.colorVar } : {}),
              }}>
              {plan.cta}
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}

// ─── Admin Dashboard ──────────────────────────────────────────────────────────
function AdminDashboard({ setPage }) {
  const colorMap = { neon: "#bc13fe", blue: "#00d4ff", pink: "#ff2d78", green: "#39ff14" };
  const iconMap  = { neon: Users2, blue: DollarSign, pink: Radio, green: Mic2 };

  return (
    <div className="animate-fade">
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 32 }}>
        <div>
          <div className="tag tag-pink" style={{ marginBottom: 8 }}>
            <Shield size={10} style={{ marginRight: 4 }} /> Admin Suite
          </div>
          <h1 style={{ fontSize: 36, fontWeight: 800, letterSpacing: "-0.03em" }}>Dashboard</h1>
        </div>
        <button className="ghost-btn" style={{ padding: "10px 20px", borderRadius: 10, fontSize: 13, display: "flex", alignItems: "center", gap: 8 }}
          onClick={() => setPage({ name: "adminPanel" })}>
          <Settings size={14} /> Admin Panel
        </button>
      </div>

      <div className="grid-4" style={{ marginBottom: 40 }}>
        {ADMIN_STATS?.map(s => {
          const color = colorMap[s.colorKey];
          const Icon  = iconMap[s.colorKey];
          return (
            <div key={s.label} className="glass card-hover" style={{ borderRadius: 16, padding: 24, position: "relative", overflow: "hidden" }}>
              <NeonOrb style={{ width: 150, height: 150, background: `${color}20`, right: -40, top: -40 }} />
              <div style={{ position: "relative", zIndex: 1 }}>
                <div style={{ width: 44, height: 44, borderRadius: 12, display: "flex", alignItems: "center", justifyContent: "center", background: `${color}20`, marginBottom: 16 }}>
                  <Icon size={22} color={color} />
                </div>
                <div className="mono" style={{ fontSize: 32, fontWeight: 800, letterSpacing: "-0.03em", marginBottom: 4, color }}>{s.value}</div>
                <div style={{ color: "var(--text-dim)", fontSize: 13, marginBottom: 8 }}>{s.label}</div>
                <div className="tag tag-green" style={{ fontSize: 10 }}>{s.change}</div>
              </div>
            </div>
          );
        })}
      </div>

      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 24 }}>
        <div className="glass" style={{ borderRadius: 16, padding: 24 }}>
          <div style={{ fontWeight: 800, fontSize: 18, marginBottom: 20, display: "flex", alignItems: "center", gap: 8 }}>
            <TrendingUp size={18} color="#bc13fe" /> Top Streaming Tracks
          </div>
          {TRACKS?.slice(0, 5).map((t, i) => (
            <div key={t.id} style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 12 }}>
              <span className="mono" style={{ color: "var(--neon)", fontWeight: 800, fontSize: 14, width: 20 }}>{i + 1}</span>
              <img src={t.img} alt="" style={{ width: 36, height: 36, borderRadius: 6, objectFit: "cover" }} />
              <div style={{ flex: 1 }}>
                <div style={{ fontWeight: 700, fontSize: 13 }}>{t.title}</div>
                <div style={{ color: "var(--text-dim)", fontSize: 11 }}>{t.artist}</div>
              </div>
              <div className="mono" style={{ color: "var(--text-dim)", fontSize: 12 }}>{t.plays}</div>
            </div>
          ))}
        </div>
        <div className="glass" style={{ borderRadius: 16, padding: 24 }}>
          <div style={{ fontWeight: 800, fontSize: 18, marginBottom: 20, display: "flex", alignItems: "center", gap: 8 }}>
            <BarChart2 size={18} color="#00d4ff" /> Revenue by Plan
          </div>
          {[
            { plan: "Pro", pct: 68, val: "$576K", color: "#bc13fe" },
            { plan: "Student", pct: 24, val: "$203K", color: "#00d4ff" },
            { plan: "Free", pct: 8, val: "$68K", color: "#ff2d78" },
          ].map(r => (
            <div key={r.plan} style={{ marginBottom: 20 }}>
              <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 8 }}>
                <span style={{ fontWeight: 700, fontSize: 14 }}>{r.plan}</span>
                <span style={{ color: r.color, fontWeight: 700, fontSize: 14 }}>{r.val}</span>
              </div>
              <div style={{ height: 8, background: "rgba(255,255,255,0.08)", borderRadius: 4 }}>
                <div style={{ height: "100%", width: `${r.pct}%`, background: r.color, borderRadius: 4, boxShadow: `0 0 8px ${r.color}60` }} />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

// ─── Admin Panel ──────────────────────────────────────────────────────────────
function AdminPanel() {
  const [activeTab, setActiveTab] = useState("songs");
  const tabs = ["songs", "artists", "users"];

  return (
    <div className="animate-fade">
      <h1 style={{ fontSize: 36, fontWeight: 800, letterSpacing: "-0.03em", marginBottom: 8 }}>
        Admin <span style={{ color: "var(--neon)" }}>Panel</span>
      </h1>
      <p style={{ color: "var(--text-dim)", marginBottom: 32 }}>Manage songs, artists, and users</p>
      <div style={{ display: "flex", gap: 8, marginBottom: 24 }}>
        {tabs.map(t => (
          <button key={t} onClick={() => setActiveTab(t)} style={{
            padding: "10px 20px", borderRadius: 10, fontSize: 13, fontWeight: 700,
            cursor: "pointer", transition: "all 0.2s", fontFamily: "Syne, sans-serif", border: "1px solid",
            background: activeTab === t ? "var(--neon)" : "transparent",
            borderColor: activeTab === t ? "var(--neon)" : "var(--glass-border)",
            color: activeTab === t ? "#fff" : "var(--text-dim)",
            textTransform: "capitalize",
          }}>{t}</button>
        ))}
      </div>
      <div className="glass" style={{ borderRadius: 16, overflow: "hidden" }}>
        {activeTab === "songs" && (
          <table>
            <thead><tr><th>#</th><th>Title</th><th>Artist</th><th>Streams</th><th>Status</th><th>Actions</th></tr></thead>
            <tbody>
              {ADMIN_SONGS?.map((s, i) => (
                <tr key={s.id}>
                  <td className="mono" style={{ color: "var(--text-dim)" }}>{i + 1}</td>
                  <td style={{ fontWeight: 600 }}>{s.title}</td>
                  <td style={{ color: "var(--text-dim)" }}>{s.artist}</td>
                  <td className="mono" style={{ color: "var(--blue)" }}>{s.streams}</td>
                  <td><span className={`tag ${s.status === "Active" ? "tag-green" : "tag-neon"}`} style={{ fontSize: 10 }}>{s.status}</span></td>
                  <td><div style={{ display: "flex", gap: 6 }}>
                    <button className="ghost-btn" style={{ padding: "4px 12px", borderRadius: 6, fontSize: 12 }}>Edit</button>
                    <button style={{ padding: "4px 12px", borderRadius: 6, fontSize: 12, background: "rgba(255,45,120,0.1)", border: "1px solid rgba(255,45,120,0.3)", color: "#ff2d78", cursor: "pointer", fontFamily: "Syne, sans-serif", fontWeight: 700 }}>Delete</button>
                  </div></td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
        {activeTab === "artists" && (
          <table>
            <thead><tr><th>#</th><th>Artist</th><th>Genre</th><th>Followers</th><th>Status</th><th>Actions</th></tr></thead>
            <tbody>
              {ARTISTS?.map((a, i) => (
                <tr key={a.id}>
                  <td className="mono" style={{ color: "var(--text-dim)" }}>{i + 1}</td>
                  <td><div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                    <img src={a.img} alt="" style={{ width: 32, height: 32, borderRadius: "50%", objectFit: "cover" }} />
                    <span style={{ fontWeight: 600 }}>{a.name}</span>
                  </div></td>
                  <td><span className="tag tag-neon" style={{ fontSize: 10 }}>{a.genre}</span></td>
                  <td className="mono" style={{ color: "var(--blue)" }}>{a.followers}</td>
                  <td><span className="tag tag-green" style={{ fontSize: 10 }}>Verified</span></td>
                  <td><div style={{ display: "flex", gap: 6 }}>
                    <button className="ghost-btn" style={{ padding: "4px 12px", borderRadius: 6, fontSize: 12 }}>Edit</button>
                    <button style={{ padding: "4px 12px", borderRadius: 6, fontSize: 12, background: "rgba(255,45,120,0.1)", border: "1px solid rgba(255,45,120,0.3)", color: "#ff2d78", cursor: "pointer", fontFamily: "Syne, sans-serif", fontWeight: 700 }}>Remove</button>
                  </div></td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
        {activeTab === "users" && (
          <table>
            <thead><tr><th>#</th><th>User</th><th>Email</th><th>Plan</th><th>Role</th><th>Joined</th><th>Actions</th></tr></thead>
            <tbody>
              {ADMIN_USERS?.map((u, i) => (
                <tr key={u.id}>
                  <td className="mono" style={{ color: "var(--text-dim)" }}>{i + 1}</td>
                  <td style={{ fontWeight: 600 }}>{u.name}</td>
                  <td style={{ color: "var(--text-dim)", fontSize: 13 }}>{u.email}</td>
                  <td><span className={`tag ${u.plan === "Pro" ? "tag-neon" : u.plan === "Student" ? "tag-blue" : "tag-pink"}`} style={{ fontSize: 10 }}>{u.plan}</span></td>
                  <td style={{ color: u.role === "Admin" ? "var(--neon)" : u.role === "Moderator" ? "var(--blue)" : "var(--text-dim)", fontSize: 13, fontWeight: 600 }}>{u.role}</td>
                  <td style={{ color: "var(--text-dim)", fontSize: 13 }}>{u.joined}</td>
                  <td><div style={{ display: "flex", gap: 6 }}>
                    <button className="ghost-btn" style={{ padding: "4px 12px", borderRadius: 6, fontSize: 12 }}>Edit</button>
                    <button style={{ padding: "4px 12px", borderRadius: 6, fontSize: 12, background: "rgba(255,45,120,0.1)", border: "1px solid rgba(255,45,120,0.3)", color: "#ff2d78", cursor: "pointer", fontFamily: "Syne, sans-serif", fontWeight: 700 }}>Ban</button>
                  </div></td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}

// ─── Auth ─────────────────────────────────────────────────────────────────────
function AuthPage({ mode, setMode, onAuth }) {
  const [showPwd, setShowPwd] = useState(false);
  const [form, setForm]       = useState({ name: "", email: "", password: "" });
  const [errors, setErrors]   = useState({});

  const validate = () => {
    const e = {};
    if (mode === "signup" && !form.name.trim()) e.name = "Name is required";
    if (!form.email.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)) e.email = "Valid email required";
    if (form.password.length < 6) e.password = "Password must be 6+ characters";
    setErrors(e);
    return Object.keys(e).length === 0;
  };

  return (
    <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", background: "var(--bg)", position: "relative", overflow: "hidden" }}>
      <NeonOrb style={{ width: 600, height: 600, background: "rgba(188,19,254,0.08)", top: -200, left: -200 }} />
      <NeonOrb style={{ width: 400, height: 400, background: "rgba(0,212,255,0.06)", bottom: -100, right: -100 }} />

      <div className="glass animate-up" style={{ borderRadius: 24, padding: "48px 40px", width: "100%", maxWidth: 420, position: "relative", zIndex: 1 }}>
        <div style={{ textAlign: "center", marginBottom: 36 }}>
          <div style={{ width: 56, height: 56, borderRadius: 16, background: "linear-gradient(135deg,#bc13fe,#7b00cc)", display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 16px", boxShadow: "0 0 30px rgba(188,19,254,0.5)" }}>
            <Headphones size={28} color="#fff" />
          </div>
          <div style={{ fontSize: 26, fontWeight: 800, letterSpacing: "-0.03em" }}>
            <span className="glow-text" style={{ color: "var(--neon)" }}>FLOW</span>
            <span style={{ color: "var(--text-dim)" }}>STATE</span>
          </div>
          <div style={{ color: "var(--text-dim)", fontSize: 14, marginTop: 4 }}>
            {mode === "login" ? "Welcome back" : "Join the movement"}
          </div>
        </div>

        <div style={{ display: "flex", gap: 8, marginBottom: 28, background: "rgba(255,255,255,0.04)", borderRadius: 12, padding: 4 }}>
          {["login", "signup"].map(m => (
            <button key={m} onClick={() => { setMode(m); setErrors({}); }} style={{
              flex: 1, padding: "10px", borderRadius: 9, border: "none", cursor: "pointer",
              fontFamily: "Syne, sans-serif", fontWeight: 700, fontSize: 14, transition: "all 0.2s",
              background: mode === m ? "var(--neon)" : "transparent",
              color: mode === m ? "#fff" : "var(--text-dim)",
              boxShadow: mode === m ? "0 0 16px rgba(188,19,254,0.4)" : "none",
            }}>{m === "login" ? "Sign In" : "Sign Up"}</button>
          ))}
        </div>

        <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
          {mode === "signup" && (
            <div>
              <div style={{ position: "relative" }}>
                <input value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} placeholder="Your name" style={{ paddingLeft: 44 }} />
                <Users size={16} style={{ position: "absolute", left: 14, top: "50%", transform: "translateY(-50%)", color: "var(--text-dim)" }} />
              </div>
              {errors.name && <div style={{ color: "#ff2d78", fontSize: 12, marginTop: 4 }}>{errors.name}</div>}
            </div>
          )}
          <div>
            <div style={{ position: "relative" }}>
              <input value={form.email} onChange={e => setForm({ ...form, email: e.target.value })} placeholder="Email address" type="email" style={{ paddingLeft: 44 }} />
              <Mail size={16} style={{ position: "absolute", left: 14, top: "50%", transform: "translateY(-50%)", color: "var(--text-dim)" }} />
            </div>
            {errors.email && <div style={{ color: "#ff2d78", fontSize: 12, marginTop: 4 }}>{errors.email}</div>}
          </div>
          <div>
            <div style={{ position: "relative" }}>
              <input value={form.password} onChange={e => setForm({ ...form, password: e.target.value })} placeholder="Password" type={showPwd ? "text" : "password"} style={{ paddingLeft: 44, paddingRight: 44 }} />
              <Lock size={16} style={{ position: "absolute", left: 14, top: "50%", transform: "translateY(-50%)", color: "var(--text-dim)" }} />
              <button onClick={() => setShowPwd(!showPwd)} style={{ position: "absolute", right: 14, top: "50%", transform: "translateY(-50%)", background: "transparent", border: "none", cursor: "pointer", color: "var(--text-dim)" }}>
                {showPwd ? <EyeOff size={16} /> : <Eye size={16} />}
              </button>
            </div>
            {errors.password && <div style={{ color: "#ff2d78", fontSize: 12, marginTop: 4 }}>{errors.password}</div>}
          </div>
        </div>

        <button className="neon-btn" onClick={() => { if (validate()) onAuth({ name: form.name || "HipHop Fan", email: form.email, plan: "Free" }); }}
          style={{ width: "100%", padding: "14px", borderRadius: 12, fontSize: 16, marginTop: 24, marginBottom: 16 }}>
          {mode === "login" ? "Sign In" : "Create Account"}
        </button>

        {mode === "login" && <div style={{ textAlign: "center" }}>
          <span style={{ color: "var(--neon)", fontSize: 13, cursor: "pointer", fontWeight: 600 }}>Forgot password?</span>
        </div>}

        <div style={{ display: "flex", alignItems: "center", gap: 12, margin: "20px 0" }}>
          <div style={{ flex: 1, height: 1, background: "rgba(255,255,255,0.08)" }} />
          <span style={{ color: "var(--text-dim)", fontSize: 12 }}>or continue with</span>
          <div style={{ flex: 1, height: 1, background: "rgba(255,255,255,0.08)" }} />
        </div>
        <div style={{ display: "flex", gap: 10 }}>
          {["Google", "Apple", "Twitter"].map(p => (
            <button key={p} className="ghost-btn" style={{ flex: 1, padding: "10px", borderRadius: 10, fontSize: 13 }}>{p}</button>
          ))}
        </div>
      </div>
    </div>
  );
}

// ─── Player ───────────────────────────────────────────────────────────────────
// IMPORTANT: ALL hooks are declared FIRST, before any conditional return.
// This satisfies the Rules of Hooks — hooks must never be called conditionally.
function Player({ track, isPlaying, setIsPlaying }) {
  const [progress, setProgress] = useState(32);
  const [volume,   setVolume]   = useState(75);
  const [muted,    setMuted]    = useState(false);
  const [shuffled, setShuffled] = useState(false);
  const [repeated, setRepeated] = useState(false);
  const [liked,    setLiked]    = useState(false);

  useEffect(() => {
    let interval;
    if (isPlaying) {
      interval = setInterval(() => setProgress(p => p >= 100 ? 0 : p + 0.1), 100);
    }
    return () => clearInterval(interval);
  }, [isPlaying]);

  // Conditional return is SAFE here because all hooks are already declared above
  if (!track) return (
    <div className="glass" style={{
      position: "fixed", bottom: 0, left: 0, right: 0, height: "var(--player-h)",
      borderTop: "1px solid var(--glass-border)", display: "flex",
      alignItems: "center", justifyContent: "center", zIndex: 100,
    }}>
      <div style={{ color: "var(--text-dim)", fontSize: 14 }}>
        <Headphones size={16} style={{ marginRight: 8, verticalAlign: "middle" }} />
        Select a track to start listening
      </div>
    </div>
  );

  return (
    <div className="glass" style={{
      position: "fixed", bottom: 0, left: 0, right: 0, height: "var(--player-h)",
      borderTop: "1px solid var(--glass-border)", zIndex: 100,
      display: "flex", flexDirection: "column", justifyContent: "center",
      background: "rgba(8,8,16,0.92)",
    }}>
      <div className="progress-bar" style={{ position: "absolute", top: 0, left: 0, right: 0, borderRadius: 0 }}
        onClick={e => { const r = e.currentTarget.getBoundingClientRect(); setProgress(((e.clientX - r.left) / r.width) * 100); }}>
        <div className="progress-fill" style={{ width: `${progress}%` }} />
      </div>

      <div style={{ display: "grid", gridTemplateColumns: "1fr auto 1fr", alignItems: "center", padding: "0 24px", height: "100%" }}>
        {/* Track Info */}
        <div style={{ display: "flex", alignItems: "center", gap: 14 }}>
          <div style={{ position: "relative" }}>
            <img src={track.img} alt="" className={`vinyl-spin ${isPlaying ? "playing" : ""}`}
              style={{ width: 52, height: 52, borderRadius: "50%", objectFit: "cover", border: "2px solid rgba(188,19,254,0.3)" }} />
            <div style={{ position: "absolute", inset: 0, borderRadius: "50%", background: "radial-gradient(circle, transparent 30%, rgba(0,0,0,0.4) 100%)" }} />
          </div>
          <div>
            <div style={{ fontWeight: 700, fontSize: 14, marginBottom: 2, color: isPlaying ? "var(--neon)" : "var(--text)" }}>{track.title}</div>
            <div style={{ color: "var(--text-dim)", fontSize: 12 }}>{track.artist}</div>
          </div>
          <button onClick={() => setLiked(!liked)} className="icon-btn">
            <Heart size={16} color={liked ? "#ff2d78" : undefined} fill={liked ? "#ff2d78" : "none"} />
          </button>
        </div>

        {/* Controls */}
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <button className="icon-btn" onClick={() => setShuffled(!shuffled)} style={{ color: shuffled ? "var(--neon)" : undefined }}>
            <Shuffle size={16} />
          </button>
          <button className="icon-btn" style={{ padding: 10 }}><SkipBack size={20} /></button>
          <button onClick={() => setIsPlaying(!isPlaying)} style={{
            width: 48, height: 48, borderRadius: "50%",
            background: "linear-gradient(135deg,#bc13fe,#7b00cc)", border: "none", cursor: "pointer",
            display: "flex", alignItems: "center", justifyContent: "center",
            boxShadow: isPlaying ? "0 0 24px rgba(188,19,254,0.6), 0 0 48px rgba(188,19,254,0.2)" : "0 0 16px rgba(188,19,254,0.3)",
            transition: "all 0.2s",
          }}>
            {isPlaying
              ? <Pause size={20} color="#fff" fill="#fff" />
              : <Play size={20} color="#fff" fill="#fff" style={{ marginLeft: 2 }} />}
          </button>
          <button className="icon-btn" style={{ padding: 10 }}><SkipForward size={20} /></button>
          <button className="icon-btn" onClick={() => setRepeated(!repeated)} style={{ color: repeated ? "var(--neon)" : undefined }}>
            <Repeat size={16} />
          </button>
        </div>

        {/* Volume */}
        <div style={{ display: "flex", alignItems: "center", gap: 10, justifyContent: "flex-end" }}>
          <span className="mono" style={{ color: "var(--text-dim)", fontSize: 12, minWidth: 60, textAlign: "right" }}>
            {formatTime(progress)}
          </span>
          <button className="icon-btn" onClick={() => setMuted(!muted)}>
            {muted ? <VolumeX size={18} /> : <Volume2 size={18} />}
          </button>
          <div className="vol-bar" onClick={e => { const r = e.currentTarget.getBoundingClientRect(); setVolume(Math.round(((e.clientX - r.left) / r.width) * 100)); }}>
            <div className="vol-fill" style={{ width: `${muted ? 0 : volume}%` }} />
          </div>
        </div>
      </div>
    </div>
  );
}

// ═══════════════════════════════════════════════════════════════════════════════
//  ROOT APP — single export default, all hooks unconditionally at the top
// ═══════════════════════════════════════════════════════════════════════════════
export default function App() {
  // ── All useState calls are at the very top, before any conditional logic ──
  const [authed,          setAuthed]          = useState(false);
  const [authMode,        setAuthMode]        = useState("login");
  const [user,            setUser]            = useState({ name: "HipHop Fan", email: "user@example.com", plan: "Pro" });
  const [page,            setPage]            = useState({ name: "home" });
  const [currentTrack,    setCurrentTrack]    = useState(null);
  const [isPlaying,       setIsPlaying]       = useState(false);
  const [sidebarOpen,     setSidebarOpen]     = useState(true);
  const [followedArtists, setFollowedArtists] = useState(new Set([1, 3]));

  const handleSetTrack = (track) => { setCurrentTrack(track); setIsPlaying(true); };
  const toggleFollow   = (id)    => setFollowedArtists(s => { const n = new Set(s); n.has(id) ? n.delete(id) : n.add(id); return n; });

  const navItems = [
    { icon: Home,    label: "Home",          name: "home"    },
    { icon: Search,  label: "Search",        name: "search"  },
    { icon: Library, label: "Library",       name: "library" },
    { icon: Heart,   label: "Liked Songs",   name: "library" },
    { icon: Users,   label: "Following",     name: "library" },
  ];
  const adminItems = [
    { icon: BarChart2, label: "Dashboard",  name: "admin"      },
    { icon: Shield,    label: "Admin Panel",name: "adminPanel" },
  ];

  const renderPage = () => {
    const props = { setPage, currentTrack, setCurrentTrack: handleSetTrack };
    switch (page.name) {
      case "home":        return <HomePage       {...props} />;
      case "search":      return <SearchPage     {...props} />;
      case "library":     return <LibraryPage    {...props} />;
      case "artist":      return <ArtistPage     {...props} artist={page.data} followed={followedArtists.has(page.data?.id)} toggleFollow={toggleFollow} />;
      case "album":       return <AlbumPage      currentTrack={currentTrack} setCurrentTrack={handleSetTrack} album={page.data} />;
      case "profile":     return <ProfilePage    user={user} setUser={setUser} />;
      case "subscription":return <SubscriptionPage />;
      case "admin":       return <AdminDashboard setPage={setPage} />;
      case "adminPanel":  return <AdminPanel />;
      default:            return <HomePage       {...props} />;
    }
  };

  // Conditional return is AFTER all hooks — this is correct and safe
  if (!authed) return <AuthPage mode={authMode} setMode={setAuthMode} onAuth={(u) => { setUser(u); setAuthed(true); }} />;

  return (
    <div className="noise-bg" style={{ display: "flex", minHeight: "100vh" }}>
      {/* ── Sidebar ── */}
      <div className="glass" style={{
        width: sidebarOpen ? "var(--sidebar-w)" : 0,
        flexShrink: 0, height: "100vh", position: "sticky", top: 0,
        borderRight: "1px solid var(--glass-border)",
        display: "flex", flexDirection: "column",
        transition: "width 0.3s", overflow: "hidden", zIndex: 50,
      }}>
        {/* Logo */}
        <div style={{ padding: "20px 16px", borderBottom: "1px solid rgba(255,255,255,0.05)", flexShrink: 0 }}>
          <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <div style={{ width: 38, height: 38, borderRadius: 10, background: "linear-gradient(135deg,#bc13fe,#7b00cc)", display: "flex", alignItems: "center", justifyContent: "center", boxShadow: "0 0 16px rgba(188,19,254,0.4)", flexShrink: 0 }}>
              <Headphones size={20} color="#fff" />
            </div>
            <div style={{ whiteSpace: "nowrap" }}>
              <span style={{ fontWeight: 800, fontSize: 18, letterSpacing: "-0.03em" }}>
                <span className="glow-text" style={{ color: "var(--neon)" }}>FLOW</span>
                <span style={{ color: "var(--text-dim)" }}>STATE</span>
              </span>
            </div>
          </div>
        </div>

        {/* Nav */}
        <nav style={{ padding: "16px 12px", flex: 1, overflowY: "auto" }}>
          <div style={{ fontSize: 10, color: "var(--text-dim)", fontWeight: 700, letterSpacing: "0.12em", textTransform: "uppercase", marginBottom: 10, marginLeft: 4 }}>Main</div>
          {navItems.map(item => (
            <a key={item.label} className={`sidebar-link ${page.name === item.name ? "active" : ""}`}
              onClick={() => setPage({ name: item.name })} style={{ whiteSpace: "nowrap", marginBottom: 2 }}>
              <item.icon size={18} />{item.label}
            </a>
          ))}
          <div style={{ fontSize: 10, color: "var(--text-dim)", fontWeight: 700, letterSpacing: "0.12em", textTransform: "uppercase", margin: "20px 0 10px 4px" }}>Admin</div>
          {adminItems.map(item => (
            <a key={item.name} className={`sidebar-link ${page.name === item.name ? "active" : ""}`}
              onClick={() => setPage({ name: item.name })} style={{ whiteSpace: "nowrap", marginBottom: 2 }}>
              <item.icon size={18} />{item.label}
            </a>
          ))}
          <div style={{ fontSize: 10, color: "var(--text-dim)", fontWeight: 700, letterSpacing: "0.12em", textTransform: "uppercase", margin: "20px 0 10px 4px" }}>Quick Access</div>
          {ALBUMS?.slice(0, 4).map(a => (
            <a key={a.id} className="sidebar-link" onClick={() => setPage({ name: "album", data: a })} style={{ whiteSpace: "nowrap", marginBottom: 2 }}>
              <img src={a.img} alt="" style={{ width: 18, height: 18, borderRadius: 4, objectFit: "cover" }} />
              <span style={{ fontSize: 13 }}>{a.title}</span>
            </a>
          ))}
        </nav>

        {/* User */}
        <div style={{ padding: "16px 12px", borderTop: "1px solid rgba(255,255,255,0.05)" }}>
          <div className="glass" style={{ padding: "12px", borderRadius: 12, display: "flex", alignItems: "center", gap: 10, cursor: "pointer" }}
            onClick={() => setPage({ name: "profile" })}>
            <img src={`https://picsum.photos/seed/${user.name}/40/40`} alt="" style={{ width: 36, height: 36, borderRadius: "50%", objectFit: "cover" }} />
            <div style={{ flex: 1, overflow: "hidden", whiteSpace: "nowrap" }}>
              <div style={{ fontWeight: 700, fontSize: 13, overflow: "hidden", textOverflow: "ellipsis" }}>{user.name}</div>
              <div style={{ color: "var(--neon)", fontSize: 11 }}>{user.plan} Plan</div>
            </div>
            <Settings size={14} color="var(--text-dim)" />
          </div>
          <button className="ghost-btn" style={{ width: "100%", padding: "10px", borderRadius: 10, fontSize: 13, marginTop: 8, display: "flex", alignItems: "center", justifyContent: "center", gap: 6 }}
            onClick={() => setPage({ name: "subscription" })}>
            <Crown size={14} /> Upgrade
          </button>
        </div>
      </div>

      {/* ── Main ── */}
      <div style={{ flex: 1, display: "flex", flexDirection: "column", minWidth: 0 }}>
        {/* Topbar */}
        <div style={{ padding: "16px 28px", display: "flex", alignItems: "center", gap: 16, position: "sticky", top: 0, zIndex: 40, background: "linear-gradient(to bottom, rgba(8,8,16,0.95), transparent)", backdropFilter: "blur(8px)" }}>
          <button className="icon-btn" onClick={() => setSidebarOpen(!sidebarOpen)} style={{ borderRadius: 8 }}><Menu size={20} /></button>
          {page.name !== "home" && (
            <button className="icon-btn" onClick={() => setPage({ name: "home" })} style={{ borderRadius: 8 }}><ArrowLeft size={20} /></button>
          )}
          <div style={{ flex: 1 }} />
          <button className="icon-btn"><Bell size={18} /></button>
          <div style={{ width: 36, height: 36, borderRadius: "50%", overflow: "hidden", border: "2px solid rgba(188,19,254,0.4)", cursor: "pointer" }}
            onClick={() => setPage({ name: "profile" })}>
            <img src={`https://picsum.photos/seed/${user.name}/36/36`} alt="" style={{ width: "100%", height: "100%", objectFit: "cover" }} />
          </div>
        </div>

        {/* Content */}
        <div style={{ flex: 1, padding: "0 28px 24px", overflowY: "auto", paddingBottom: "calc(var(--player-h) + 24px)" }}>
          {renderPage()}
        </div>
      </div>

      {/* ── Player ── */}
      <Player track={currentTrack} isPlaying={isPlaying} setIsPlaying={setIsPlaying} />
    </div>
  );
}